import { useContext, useMemo } from 'react'
import { UseFormWatch } from 'react-hook-form'
import { isCountryCode, Rate, Rates } from 'src/subscribe'
import { Context } from 'src/Subscribe_'
import type { FieldValues } from './RecipientsInformation'

export default function AutoChargeTerms({
  rates,
  terms,
  watch,
}: {
  rates: Rates
  terms: string | null
  watch: UseFormWatch<FieldValues>
}) {
  const { state } = useContext(Context)
  const countryCode = watch('address.country_code')

  const amountInDollars: string | null = useMemo(() => {
    if (!state.values.rate_nid) {
      return null
    }
    const rate: Rate | undefined = rates[state.values.rate_nid]
    if (rate === undefined) {
      return null
    }
    if (countryCode === 'US') {
      return rate.price_in_dollars
    }
    if (!isCountryCode(countryCode)) {
      return null
    }
    const ip: string | undefined =
      rate.international_prices[countryCode].amount_in_dollars
    return ip || null
  }, [countryCode, rates, state.values.rate_nid])

  const html: string | null = useMemo(() => {
    if (!terms || !amountInDollars) {
      return null
    }
    return terms.replace(/\{amount_in_dollars\}/, amountInDollars)
  }, [amountInDollars, terms])

  if (!html) {
    return null
  }

  return (
    <div
      className="field--name-field-banner"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  )
}
